import { useSelector } from 'react-redux';

const useTheme = () => {
  const { theme } = useSelector(state => state.app);
  return theme;
};

export default useTheme;
